<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
	
		
		<div class="read">
			<div class="read-hd">
				<q-title title="打印发票" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>
			
			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>9527</b>
				</div>
			</div>
			
			
			<div class="print-list-tiems">
				
				<div class="print-item-head">
					<div class="col1">勾选</div>
					<div class="col2">发票发码</div>
					<div class="col3">金额(元)</div>
					<div class="col4">发票日期</div>
					<div class="col5">打印次数</div>
					<div class="col6">&nbsp;</div>
				</div>
				<div class="print-item on">
					<div class="col1">
						<img src="../../assets/icon/icon-check2.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div>
				<div class="print-item">
					<div class="col1">
						<img src="../../assets/icon/icon-check2.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div>
				<div class="print-item">
					<div class="col1">
						<img src="../../assets/icon/icon-check.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div>
				<div class="print-item">
					<div class="col1">
						<img src="../../assets/icon/icon-check.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div><div class="print-item">
					<div class="col1">
						<img src="../../assets/icon/icon-check.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div><div class="print-item">
					<div class="col1">
						<img src="../../assets/icon/icon-check.png" >
					</div>
					<div class="col2">
						<div class="name">154165416510</div>
					</div>
					<div class="col3">
						<div class="money">
							54135
						</div>
					</div>
					<div class="col4">
						<div class="time">
							2021-12-03 22:45:39
						</div>
					</div>
					<div class="col5">
						<div>
							2
						</div>
					</div>
					<div class="col6">
						<div class="fcc">
							
							<button type="button" class="btn-print" @click="toPrint">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			
			
			
			<div class="fc-bet">
				<div class="red-tips">
					*温馨提示：自助发票只可打印一次，重复打印请到人工窗口。
				</div>
				<div class="list-page fcc">
					<a>上一页</a>
					<span>第</span>
					<span>1/15</span>
					<span>页</span>
					<a>下一页</a>
				</div>
			</div>
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				<a class="btn-blue fcc"  @click="toPrint">
					<img src="../../assets/icon/printer.png" >
					<span>全部打印</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		
		
		
		<!-- 打印中 -->
		<qPrintIng v-if="printIngShow"></qPrintIng>
		<!-- 打印ok -->
		<qPopPrintOk v-if="printOk" @close-read="closeReadList"></qPopPrintOk>
		
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	import qPrintIng from '@/components/q-pop/q-pop-print-ing.vue';
	import qPopPrintOk from '@/components/q-pop/q-pop-print.vue';
	export default {
		components: {
			qHead,qBanner,qStep,qTitle,qPrintIng,qPopPrintOk
		},
		data() {
			return {
			
				printIngShow:false,
				printOk:false
			}
		},
		mounted() {
			
		},
		methods:{
			
			
			//点击打印按钮
			toPrint(){
				var that=this;
				that.printIngShow=true
				that.printOk=false
				//模拟3秒打印完成 关闭正在打印中
				setTimeout(()=>{
					that.printIngShow=false
					// 显示打印完成
					that.printOk = true
				},3000)
			},
			closeReadList() {
			  this.printOk = false
			},
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	.print-item .btn-print{

			background: linear-gradient(0deg, #029897, #1AB9B4);
			margin-right: 0;
	}
	.print-item-head{
		
		height: 74px;background: #1EB3B1;
		font-size: 30px;
		color: #fff;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	.print-list-tiems{
		.col1{
			width: 87px;text-align: center;
			padding: 0;
			img{
				margin: 0 auto;
			}
		}
		.col2{
			width: 253px;
			text-align: center;
			
		}
		.col3{
			width: 147px;text-align: center;
			font-size: 23px;
			
		}
		.col4{
			width: 249px;text-align: center;
		}
		.col5{
			width: 140px;text-align: center;
		}
		.col6{
			width: 144px;text-align: center;
		}
	}
	.print-item{
		.col2~div{
			font-size: 23px;
			color: #7F7F7F;
		}
	}
	.print-item .name{
		width: 253px;
	}
</style>
